import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('PureMultipleChoiceExercise', LATEST_SCHEMA_VERSION.PureMultipleChoiceExercise);
export default exerciseTypeVersionAdapter;